export default "__VITE_ASSET__newsAMZz__"